import { useState, useEffect, useCallback } from 'react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  const checkMobile = useCallback(() => {
    // Check screen width
    const isSmallScreen = window.innerWidth <= 768;
    
    // Check user agent for mobile devices
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    
    // Check for touch capability
    const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Consider it mobile if any of these conditions are true
    const newIsMobile = isSmallScreen || (isMobileDevice && hasTouchScreen);
    
    // Only update state if value actually changed to prevent unnecessary re-renders
    setIsMobile(prev => prev !== newIsMobile ? newIsMobile : prev);
  }, []);

  useEffect(() => {
    // Check on mount
    checkMobile();

    // Debounce resize events to prevent excessive re-renders
    let timeoutId: NodeJS.Timeout;
    const debouncedCheckMobile = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkMobile, 150); // 150ms debounce
    };

    // Listen for resize events with debouncing
    window.addEventListener('resize', debouncedCheckMobile);
    
    // Listen for orientation changes (mobile specific) with debouncing
    window.addEventListener('orientationchange', debouncedCheckMobile);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', debouncedCheckMobile);
      window.removeEventListener('orientationchange', debouncedCheckMobile);
    };
  }, [checkMobile]);

  return isMobile;
};

export default useIsMobile; 